import React from 'react';
import Icon from '../Icon/Icon';
import Link from '../Link/Link';
import Flex from '../Flex/Flex';

function DeleteIcon({ onClick }) {
  return (
    <Link onClick={onClick}>
      <Flex centeredVertically>
        <Icon
          name="close-circle"
          color="gray400"
          size="sm"
          clickableAppearance
          hoverColor="purple500"
        />
      </Flex>
    </Link>
  );
}

export default DeleteIcon;
